<template>
  <div class="card">
    <load-content :loading="isBusy">
      <div class="header">
        <h3>Briefings</h3>
      </div>
      <div v-if="isReady === true" class="body">
        <div v-if="briefings.length" class="table-file">
          <div v-for="(briefing, index) in briefings" :key="index" class="input-file align-center">
            <span class="file-name"><a target="_blank" href="" @click="(e) => {e.preventDefault(); download(briefing);}">{{briefing.file}}</a></span>
            <!-- <span><a :href="briefing.url" :download="briefing.file" target="_blank">{{briefing.file}}</a></span> -->
          </div>
        </div>
        <div v-else>
          <p class="empty-state p10 text-center">No files have been uploaded.</p>
        </div>
      </div>
    </load-content>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import LoadContent from "@/components/load-content";
import {download_file} from "@/helpers/download_file";
import _ from "lodash";
export default {
  name: "briefing-files",
  components: {
    LoadContent
  },
  methods: {
    ...mapActions({
      getBriefings: "briefings/getBriefingFiles"
    }),
    download: function(file){
      const projectUid = this.$route.params.project_uid;
      download_file(`analysis/${projectUid}/files/download`, file, this.access);
    },
  },
  created: async function () {
    const projectUid = this.$route.params.project_uid;
    this.getBriefings({ projectUid }).then(()=> {
        this.isReady = true
    });
  },
  computed: {
    ...mapState({
      isBusy: state => state.projectSetup.projectSetup.isBusy,
      briefings: state => !_.isEmpty(state.briefings.briefings.data)  ? state.briefings.briefings.data : [],
      access: state => state.user.user.data.accessToken
    })
  },
  data: function () {
      return {
          isReady: false
      }
  }
};
</script>

<style lang="scss">
@import "~@/styles/components/input-file";
</style>